export default __webpack_public_path__ + "static/media/001-M-unions.d244f8ca.svg";